import { inject } from "@angular/core";
import { CanActivateFn } from "@angular/router";
import { map } from "rxjs";
import { UserInfoService } from "../services/user-info.service";

export const currentUserDataGuard: CanActivateFn = () =>
  inject(UserInfoService)
    .getCurrentUser()
    .pipe(map((user) => Boolean(user)));
